import React from 'react';
import PropTypes from 'prop-types';
import ShareLike from '../ShareLike/ShareLike';
import './PropertyHeader.scss';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { PROPERTY_TYPE_NAME } from '../../utils/constant';
import { ArrowLeft } from '../../assets/icons';

const PropertyHeader = (props) => {
  const state = useSelector((state) => state.propertyDetails);
  const { data } = state;
  const { propertyType } = useParams();
  return (
    <div className='container-fluid property-container'>
      <div className='property-header'>
      <div className='smnav__back mb-16'>
          <Link className='text-almost-black'  to='/' replace={true}>
            <ArrowLeft verticalAlign='-7px' marginRight='12px' />
            <span className='fw-600'>View More Properties</span>
          </Link>
        </div>
        <p className='mb-0 text-taupe-80 property-header__market'>{PROPERTY_TYPE_NAME?.[propertyType]}</p>
        <div className='d-flex align-items-center justify-content-space-between propery-header__main'>
          <h3 className='mb-0 property-header__name' title={data?.data?.name}>
            {data?.data?.name}
          </h3>
          <ShareLike className='small-font' />
        </div>
      </div>
    </div>
  );
};

PropertyHeader.propTypes = {
  market: PropTypes.string,
  propertyName: PropTypes.string,
  isFavorite: PropTypes.bool,
};

export default PropertyHeader;
